import VTree from './tree'
VTree.install = function (Vue) {
  Vue.component('VTree', VTree)
}
export default VTree



// WEBPACK FOOTER //
// ./src/lib/index.js